import router from './router';
import login from './login';

export default {
  ...router,
  ...login,
};
